import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import AuthInit from './components/AuthInit';
import { PermissionProvider } from './context/PermissionContext';
import { store } from './store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <AuthInit>
          <PermissionProvider>
            <App />
            <ToastContainer position="top-right" autoClose={3000} />
          </PermissionProvider>
        </AuthInit>
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
);
